import { printHTML, downloadWord } from '../utils/printHelper';
import { useState, useEffect } from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Printer, FileDoc } from '@phosphor-icons/react';
import { toast } from 'sonner';
import axios from 'axios';
import { DateInput } from '../components/DateInput';
import ClientAutocomplete from '../components/ClientAutocomplete';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PrigovorPage() {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({
    client_id: '',
    naziv_drustva: '',
    adresa_drustva: '',
    grad: 'Podgorica',
    direktor: '',
    datum: new Date().toISOString().split('T')[0],
    objekat_naziv: '',
  });

  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/api/clients`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setClients(r.data.sort((a, b) => (a.skraceni_naziv || '').localeCompare(b.skraceni_naziv || ''))));
  }, []);

  const handleClientSelect = (clientId) => {
    const c = clients.find(cl => cl.id === clientId);
    if (c) setForm(prev => ({
      ...prev,
      client_id: clientId,
      naziv_drustva: c.naziv_firme || c.skraceni_naziv || '',
      adresa_drustva: [c.adresa, c.grad].filter(Boolean).join(', '),
      grad: c.grad || 'Podgorica',
      direktor: c.direktor || '',
      objekat_naziv: c.skraceni_naziv || c.naziv_firme || '',
    }));
  };

  const formatDatePrint = (d) => {
    if (!d) return '';
    const parts = d.split('-');
    if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`;
    return d;
  };

  const buildHtml = () => `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Obavjestenje - Prigovor</title>
<style>
@page{size:A4;margin:20mm 25mm}
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'Times New Roman',serif;font-size:12pt;color:#000;line-height:1.6;background:#fff}
.doc{max-width:170mm;margin:0 auto}
.header{font-size:11pt;line-height:1.5;margin-bottom:15px}
.title{text-align:center;font-weight:bold;font-size:14pt;letter-spacing:3px;margin:15px 0 5px}
.subtitle{text-align:center;font-weight:bold;font-size:11.5pt;margin-bottom:15px}
ul{margin:8px 0 8px 25px}
li{margin:4px 0;font-size:11pt;line-height:1.45}
ol{margin:8px 0 8px 25px}
ol li{margin:4px 0;font-size:11pt;line-height:1.45}
.section-title{font-weight:bold;font-size:11pt;margin:12px 0 5px;text-decoration:underline}
p{font-size:11pt;line-height:1.5;margin:6px 0;text-align:justify}
.sign-area{display:flex;justify-content:space-between;margin-top:30px;font-size:11pt}
.sign-left{text-align:left}
.sign-right{text-align:right;font-weight:bold}
@media print{body{margin:0}}
</style></head><body>
<div class="doc">
<div class="header">Na osnovu Čl. 27. stav 4. i 8. Zakona o zaštiti potrošača (&bdquo;Službeni list CG&ldquo; br. 012/26) i odredbi Statuta društva sa ograničenom odgovornošću &bdquo;<strong>${form.naziv_drustva}</strong>&ldquo; D.O.O. ${form.adresa_drustva}, direktor &nbsp;d&nbsp;o&nbsp;n&nbsp;o&nbsp;s&nbsp;i</div>

<div class="title">O B A V J E Š T E NJ E</div>
<div class="subtitle">O NAČINU I MJESTU PODNOŠENJA PRIGOVORA POTROŠAČA</div>

<ul>
<li>Potrošač može podnijeti prigovor u slučaju nesaobraznosti proizvoda ugovoru, u vezi sa datom komercijalnom garancijom, na račun za kupljeni proizvod i izvršene usluge ili iz drugih sličnih razloga.</li>
<li>Prigovor se podnosi na papiru ili nekom drugom potrošaču dostupnom, trajnom mediju u objektu gdje je izvršena narudžba-prodaja.</li>
<li>Kupovina proizvoda utvrđuje se na osnovu računa o kupovini, ugovora o prodaji, izjave o komercijalnoj garanciji ili na drugi odgovarajući način (izvodom iz fiskalne kase-ENU Elektronskog naplatnog mjesta, poslovne i druge odgovarajuće dokumentacije).</li>
<li>Prigovor se podnosi kod uposlenog radnika u objektu u toku radnog vremena.</li>
<li>O prijemu prigovora vodi se posebna evidencija sa obavezom čuvanja najmanje dvije godine od dana podnošenja prigovora.</li>
<li>O prigovoru potrošača odlučuje menadžer objekta ili direktor.</li>
</ul>

<div class="section-title">Obavještenje o rokovima za podnošenje prigovora</div>
<p>Potrošač može podnijeti prigovor:</p>
<ol>
<li>U slučaju nesaobraznosti proizvoda u roku od dvije godine od dana kupovine proizvoda (Čl. 51 kao i čl. 58, 60 i 74 Zakona o zaštiti potrošača)</li>
<li>U slučaju izmjene digitalnog sadržaja ili digitalne usluge u roku od 30 dana od prijema obavještenja o izmjeni ili od trenutka kada je trgovac izmijenio digitalni sadržaj ili digitalnu uslugu u zavisnosti od toga što je nastupilo kasnije,</li>
<li>U vezi sa datom komercijalnom garancijom u roku iz izjave o komercijalnoj garanciji.</li>
<li>Na račun odmah a najkasnije u roku od osam dana od dana plaćanja računa.</li>
</ol>

<div class="section-title">Rješavanje prigovora</div>
<p>Potrošaču će se u roku od osam dana od dana prijema prigovora odgovoriti u pisanoj formi na papiru ili nekom drugom potrošaču dostupnom trajnom mediju, sa izjašnjenjem o sadržini zahtjeva iz prigovora i prijedlogom za njegovo rješavanje.</p>
<p>Ukoliko se prigovor kupca rješava sa odlaganjem istom će se izdati Potvrda o prijemu prigovora shodno odredbama čl. 29. stav 2, istog zakona.</p>
<p>Shodno odredbama Čl. 27 stav 8. Zakona o zaštiti potrošača, na osnovu odluke direktora lice ovlašćeno za prijem prigovora, je radnik koji se u momentu podnošenja prigovora nalazi u objektu i koji je zaprimio prigovor potrošača.</p>

<div class="sign-area">
<div class="sign-left">${form.grad}, ${formatDatePrint(form.datum)} god.</div>
<div class="sign-right">DIREKTOR</div>
</div>
</div>
<script>window.onload=function(){window.print();window.onafterprint=function(){window.close()}}</script></body></html>`;

  const handlePrint = () => printHTML(buildHtml());
  const handleWord = () => downloadWord(buildHtml(), `Prigovor_${(form.naziv_drustva||'drustvo').replace(/\s+/g,'_')}.doc`);

  return (
    <div className="space-y-4">
      <Card className="p-4 bg-white border-slate-200">
        <h3 className="text-sm font-bold text-slate-700 mb-3">Obavještenje - Prigovor potrošača</h3>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Klijent</Label>
            <ClientAutocomplete clients={clients} value={form.client_id} onChange={(id) => (handleClientSelect)(id || 'none')} testid="prigovor-client-select" placeholder="Pretraga po nazivu ili PIB-u..." />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Grad</Label>
            <Input value={form.grad} onChange={e => setForm({...form, grad: e.target.value})} className="bg-white border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Datum</Label>
            <DateInput value={form.datum} onChange={e => setForm({...form, datum: e.target.value})} className="border-slate-300 text-sm" />
          </div>
          <div className="space-y-1">
            <Label className="text-xs text-slate-500">Direktor</Label>
            <Input value={form.direktor} onChange={e => setForm({...form, direktor: e.target.value})} className="bg-white border-slate-300 text-sm" readOnly />
          </div>
        </div>
        <div className="flex gap-2 mt-3">
          <Button onClick={handlePrint} className="bg-slate-800 hover:bg-slate-700 text-sm" disabled={!form.client_id} data-testid="print-prigovor-btn">
            <Printer size={16} className="mr-2" /> Štampaj obavještenje
          </Button>
          <Button onClick={handleWord} className="bg-indigo-600 hover:bg-indigo-700 text-sm text-white" disabled={!form.client_id} data-testid="word-prigovor-btn">
            <FileDoc size={16} className="mr-2" /> Word
          </Button>
        </div>
      </Card>
    </div>
  );
}
